import React from 'react';
import styled from 'styled-components';
import Divider from 'components/Divider';

const Category = styled.h2`
    & a {
        color: ${(props) => props.color || props.theme.colors.greyishBrown};
    }
    font-size: 20px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.greyishBrown};
`;

const DividerStyled = styled(Divider)`
    border-top: 2px solid #b7cbd9;
    margin-top: 5px;
    @media (min-width: 768px) {
        width: 100%;
    }
    min-width: 80%;
`;

interface Props {
    category: string | React.JSX.Element;
}

const Subtitle = ({ category }: Props): React.JSX.Element => {
    return (
        <>
            <Category>{category}</Category>
            <DividerStyled />
        </>
    );
};

export default Subtitle;
